import React from "react";
import TwoColumnLayout from "../../layouts/TwoColumnLayout/TwoColumnLayout";

const ManagementReports = () => {
  return <TwoColumnLayout></TwoColumnLayout>;
};

export default ManagementReports;
